import { combineReducers } from 'redux';
import appointments from './appointments';
import authentication from './authentication';
import laboratory from './laboratory';

export default combineReducers({
  authentication,
  appointments,
  laboratory
});
